import React from 'react';
import { useServerTime } from '../hooks/useServerTime';

const NavbarServerTime: React.FC = () => {
  const { isSynced, formatServerTime } = useServerTime(true, 60000);

  return (
    <div className="flex items-center space-x-2 rounded-lg border border-white/20 bg-white/10 px-3 py-1">
      <div className={`h-2 w-2 rounded-full ${isSynced ? 'bg-green-400' : 'bg-yellow-400'} animate-pulse`} />
      <span className="font-mono text-sm text-slate-100">
        {formatServerTime('time')}
      </span>
      {!isSynced && (
        <span className="text-xs text-yellow-400">Sync...</span>
      )}
    </div>
  );
};

export default NavbarServerTime;

